import {Fragment} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {PromotionBox} from "../../components/PromotionBox";
import {PromotionConsultantBox} from "./PromotionConsultantBox";

export const PromotionListListSection = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);

    return (
        <ul className={promotionBoxWrapper}>
            {!isEmpty(promotions) ? (
                <>
                    {promotions.map((promotion, index) => {
                        const shouldRenderConsultantBox = index === 2;

                        return (
                            <Fragment key={`${promotion.id}-${promotion.offer.id}`}>
                                <PromotionBox promotion={promotion} position={index + 1} />
                                {shouldRenderConsultantBox && <PromotionConsultantBox />}
                            </Fragment>
                        );
                    })}
                    {promotions.length < 3 && <PromotionConsultantBox />}
                </>
            ) : (
                <li className={emptyStateStyle}>
                    <BrandSearchIcon size="4.8" wrapperSize="6.4" wrapperColor="var(--colors-primary)" wrapperType="circle" />
                    <div className={emptyStateContentStyle}>
                        <Text as="p" variant="headline_5" className={emptyStateTitleStyle}>
                            Nie znaleźliśmy żadnych promocji
                        </Text>
                        <Text as="p" variant="body_copy_2" className={emptyStateDescriptionStyle}>
                            Zmień lokalizację lub wybierz inny rodzaj promocji
                        </Text>
                    </div>
                </li>
            )}
        </ul>
    );
};

const promotionBoxWrapper = css({
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: 3,
    m: 0,
    p: 0,
    listStyle: "none",
    md: {
        gap: 4
    }
});

const emptyStateStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    minHeight: "24.4rem",
    p: 3,
    mb: 4,
    color: "var(--colors-secondary)",
    textAlign: "center",
    listStyle: "none",
    borderRadius: 3,
    backgroundColor: "var(--colors-white)"
});

const emptyStateContentStyle = css({
    display: "grid",
    gap: 0.5,
    width: "100%"
});

const emptyStateTitleStyle = css({
    m: 0,
    color: "inherit",
    textAlign: "center"
});

const emptyStateDescriptionStyle = css({
    m: 0,
    color: "inherit",
    textAlign: "center"
});
import {Fragment} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";

import {IRPStore} from "../../../app/rp_reducer";
import {PromotionBox} from "../../components/PromotionBox";
import {PromotionConsultantBox} from "./PromotionConsultantBox";

export const PromotionListListSection = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);

    return (
        <ul className={promotionBoxWrapper}>
            {!isEmpty(promotions) ? (
                <>
                    {promotions.map((promotion, index) => {
                        const shouldRenderConsultantBox = index === 2;

                        return (
                            <Fragment key={`${promotion.id}-${promotion.offer.id}`}>
                                <PromotionBox promotion={promotion} position={index + 1} />
                                {shouldRenderConsultantBox && <PromotionConsultantBox />}
                            </Fragment>
                        );
                    })}
                    {promotions.length < 3 && <PromotionConsultantBox />}
                </>
            ) : (
                <li className={emptyStateStyle}>
                    <BrandSearchIcon size="4.8" wrapperSize="6.4" wrapperColor="var(--colors-primary)" wrapperType="circle" />
                    <div className={emptyStateContentStyle}>
                        <Text as="p" variant="headline_5" className={emptyStateTitleStyle}>
                            Nie znaleźliśmy żadnych promocji
                        </Text>
                        <Text as="p" variant="body_copy_2" className={emptyStateDescriptionStyle}>
                            Zmień lokalizację lub wybierz inny rodzaj promocji
                        </Text>
                    </div>
                </li>
            )}
        </ul>
    );
};

const promotionBoxWrapper = css({
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: 3,
    m: 0,
    p: 0,
    listStyle: "none",
    md: {
        gap: 4
    }
});

const emptyStateStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    minHeight: "24.4rem",
    p: 3,
    mb: 4,
    color: "var(--colors-secondary)",
    textAlign: "center",
    listStyle: "none",
    borderRadius: 3,
    backgroundColor: "var(--colors-white)"
});

const emptyStateContentStyle = css({
    display: "grid",
    gap: 0.5,
    width: "100%"
});

const emptyStateTitleStyle = css({
    m: 0,
    color: "inherit",
    textAlign: "center"
});

const emptyStateDescriptionStyle = css({
    m: 0,
    color: "inherit",
    textAlign: "center"
});
